var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 809 334",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.098,
    y: 58.095,
    width: 779.53,
    height: 191.55,
    fill: "#ed1c24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m317.18 118.22 29.888-15.479-9.363-18.004-29.883 15.121 9.358 18.362z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m358.95 193.12v-72.733h-79.934v20.525h14.4v52.208h-14.4v20.521h94.338v-20.521h-14.404z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m448.96 115.7v19.446c-5.396 0-10.079 4.321-10.079 10.084v12.962h10.079v15.842h-10.079v9.362c0 5.4 3.238 10.438 8.279 12.963 0.725 0.358 1.442 0.716 1.8 0.716v20.888c-12.958 0.358-26.283-2.162-39.604-7.204-12.242-4.679-21.242-13.321-26.283-25.563-10.083-23.766 0.716-51.129 24.479-60.854 13.687-6.121 27.725-8.642 41.408-8.642z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m158.04 138.03 34.921-48.25h72.734v20.52h-14.404v82.817h14.404v20.521h-94.696v-20.521h14.762v-53.65l-54.008 74.171-54.013-74.171v53.65h14.763v20.521h-52.204v-20.521h14.4v-82.817h-14.4v-20.52h82.45l35.291 48.25z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m539.34 193.12h-14.4v20.521h97.571v-20.521h-14.762v-103.34h-82.809v20.52h14.4v82.817z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m448.96 174.04v-15.842h10.446v-12.962c0-5.763-4.679-10.084-10.446-10.084v-19.446c15.125 0.363 29.888 3.963 44.292 11.167 18 9 27.725 27.363 25.2 47.167h-69.492z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m448.96 217.97v-20.888c0.721 0.363 1.084 0.363 1.804 0.721 12.963 3.959 26.646-3.6 30.605-16.562h36.366c-4.32 12.6-12.962 21.246-24.483 26.646-14.763 6.841-29.525 10.083-44.292 10.083z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m698.13 115.7v19.446c-5.767 0-10.442 4.321-10.442 10.084v12.962h10.442v15.842h-10.442v9.362c0 5.4 3.238 10.438 8.275 12.959 0.721 0.362 1.442 0.72 2.167 0.72v20.884c-13.325 0.362-26.646-2.158-39.971-7.2-12.242-4.679-20.879-13.321-26.283-25.563-10.084-23.766 1.079-51.129 24.846-60.854 13.683-6.121 27.362-8.642 41.408-8.642z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m698.13 174.04v-15.842h10.075v-12.962c-0-5.763-4.675-10.084-10.075-10.084v-19.446c14.762 0.363 29.517 3.963 44.283 11.167 18.005 9 27.721 27.363 25.205 47.167h-69.488z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m698.13 217.96v-20.884c0.354 0.363 0.717 0.363 1.438 0.721 12.962 3.959 27.004-3.6 30.962-16.562h36.371c-4.688 12.6-12.963 21.246-24.846 26.646-14.763 6.841-29.163 10.079-43.925 10.079z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiele);
export default __webpack_public_path__ + "static/media/miele.34af67715da58554ce388ce146eb5f10.svg";
export { ForwardRef as ReactComponent };